import { FC } from 'react'
import { IimagesData } from '../../../store/types'
import s from './heroSection.module.scss'
import SwiperComponent from '../../../components/Swiper/SwiperComponent'
import ReactMarkdown from 'react-markdown'

interface HeroSectionProps {
    title?: string
    title_hero_h2?:string
    images: IimagesData[]
    description_hero:any
}


const HeroSection: FC<HeroSectionProps> = ({title, images,description_hero,title_hero_h2})=>{
    return(
        <section className={s.heroSection}>
            <div className={`${s.container} container`}>
                <div className={s.titleBlock}>
                    <h2 className={`${s.title} title`}><span />{title}</h2>
                </div>
            <div className={s.heroGrid}>
                <div className={s.gallery}>
                {images && (
                        <SwiperComponent  data={images || []} />
                    )}
                </div>

                <aside className={s.heroSidebar}>
                    <div className={s.infoCard}>
                        <div className={s.cardHeader}>
                            <h3>{title_hero_h2}</h3>
                        </div>
                        
                        <div className={s.infoItem}>
                            <div className={s.infoValue}><ReactMarkdown>{description_hero ?? ''}</ReactMarkdown></div>
                        </div>
                    </div>
                </aside>
                </div>
             </div>
        </section>
    )
}

export default HeroSection